module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-bottom-bd5628ecf9ad5cd43b2d255eeab3ce40.svg";